import { FC } from 'react';

import { startCase, toLower, uniq } from 'lodash';

import moment from 'moment';

import { i18n as I18n } from '../../../utils/i18n';

import { weekdays } from '../../../constants/weekdays';

import useIsMobile from '../../../hooks/useIsMobile';

interface BookingSlot {
  name: string;
  daysOfWeek: string[];
  startTime: string;
  endTime: string;
}

interface CombinedSlots {
  [key: string]: string[];
}

interface Props {
  bookingSlots: BookingSlot[];
}

const ClinicalTimes: FC<Props> = ({ bookingSlots = [] }) => {
  const formatTime = (time: string) => moment(time).format('HH:mm');
  const isMobileView = useIsMobile();

  const weekDay = (day: string) => {
    return isMobileView ? day.charAt(0) : day;
  };

  const slotNames = uniq(
    bookingSlots.map(({ name }) => name.trim().toLowerCase())
  );

  const combinedSlots = (dayIndex: number): CombinedSlots => {
    return bookingSlots.reduce((prev, curr) => {
      const daysOfWeek = curr.daysOfWeek.map(day => (day === '0' ? '7' : day));
      const key = curr.name.trim().toLowerCase();

      if (
        daysOfWeek.includes(dayIndex.toString()) &&
        curr.endTime !== curr.startTime
      ) {
        return {
          ...prev,
          [key]: [
            ...(prev[key] || []),
            `${formatTime(curr.startTime)} - ${formatTime(curr.endTime)}`,
          ],
        };
      }

      return {
        ...prev,
        [key]: [...(prev[key] || [])],
      };
    }, {});
  };

  return (
    <>
      <thead>
        <tr>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th />
          {slotNames.map((name, index) => {
            return <th key={index}>{startCase(toLower(name))}</th>;
          })}
        </tr>
      </thead>
      <tbody>
        {weekdays.map((day, index) => {
          return (
            <tr key={day}>
              <td className="booking-times__day">{weekDay(day)}</td>
              {Object.values(combinedSlots(index + 1)).map(item => (
                <td key={item} className="booking-times__slot-hours">
                  {item.length ? item : I18n.t('shared.closed')}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </>
  );
};

export default ClinicalTimes;
